import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import ProfileHelper from 'helpers/profile'
import { setActiveDate } from 'reducers/logbookForm/reducer'

class DateFilter extends Component {
  onDateChange = value => {
    if (!this.dateRangeChange) {
      this.props.setActiveDate(moment(value))
      this.dateRangeChange = true
    } else {
      this.dateRangeChange = false
    }
  }

  render() {
    const { activeDate } = this.props
    const locale = ProfileHelper.getCurrentLocale()

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <DatePicker
          fullWidth
          autoOk
          disableToolbar
          disableFuture
          variant="inline"
          format="dd/MM/yyyy"
          id="date-picker-inline"
          value={activeDate}
          onChange={this.onDateChange}
        />
      </MuiPickersUtilsProvider>
    )
  }
}

export default connect(
  state => ({
    activeDate: state.getIn(['logbookForm', 'activeDate']),
  }),
  {
    setActiveDate,
  },
)(DateFilter)
